import { render, staticRenderFns } from "./ASemanasAula.vue?vue&type=template&id=6e2f3fda"
import script from "./ASemanasAula.vue?vue&type=script&lang=js"
export * from "./ASemanasAula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports